import type { FieldValue } from './types'

/**
 * Retrieves the value found inside the configuration context, given a string representation of
 * its path.
 * @param configuration
 * @param path
 */
export const getConfigurationValue = <
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any>,
  P extends string,
>(
  configuration: T,
  path: P,
) => {
  const keys = path.split('.')

  return keys.reduce(
    (acc, currentKey) => acc[currentKey],
    configuration,
  ) as FieldValue<T, P>
}
